import { ChangeDetectionStrategy, Component, inject, Input, OnDestroy, OnInit } from "@angular/core";
import { BehaviorSubject, Subscription } from "rxjs";
import { NxCell } from "qlik";
import { AsyncPipe } from "@angular/common";
import { QlikService } from "../../services/qlik.service";

interface KpiListeElement {
  id: string;
  value: NxCell;
  header: string;
}

@Component({
  selector: "stat-kpitabell",
  templateUrl: "./kpitabell.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe],
})
export class KpitabellComponent implements OnInit, OnDestroy {
  @Input() kpiIder: string[] = [];
  @Input() valgtFilter: string;
  @Input() statistikkType: string;

  kpiListe$: BehaviorSubject<KpiListeElement[]>;
  laster$ = new BehaviorSubject(true);

  collector: Subscription = new Subscription();

  qlikService = inject(QlikService);

  ngOnInit() {
    const kpiIderMedQlikTall = [];

    this.kpiIder.forEach((kpiId: string) => {
      kpiIderMedQlikTall.push({ id: kpiId, value: null, header: null });
    });

    this.kpiListe$ = new BehaviorSubject(kpiIderMedQlikTall);

    this.kpiIder.forEach(kpiId => {
      this.qlikService
        .getKpi(kpiId)
        .subscribe(result => {
          const gjeldendeKPIListe: KpiListeElement[] = this.kpiListe$.getValue();
          const indeksForResultat = gjeldendeKPIListe.findIndex(kpi => kpi.id === kpiId);

          if (indeksForResultat > -1) {
            gjeldendeKPIListe[indeksForResultat].value = result.value;
            gjeldendeKPIListe[indeksForResultat].header = result.header;
          }

          this.kpiListe$.next(gjeldendeKPIListe);
        })
        .add(this.collector);
    });

    this.kpiListe$
      .subscribe((liste: KpiListeElement[]) => {
        if (liste.every(element => element.value !== null)) {
          this.laster$.next(false);
        }
      })
      .add(this.collector);
  }

  hentValgtFilter() {
    let list: string[] = [];
    let valgtFilterBeskrivelse = this.statistikkType;
    list = this.qlikService.hentValgtFilterListe(this.valgtFilter);
    if (list && list.length > 0) {
      valgtFilterBeskrivelse = valgtFilterBeskrivelse + " for " + list;
    }
    return valgtFilterBeskrivelse;
  }

  ngOnDestroy() {
    this.kpiIder.forEach(kpiId => {
      this.qlikService?.destroyKpi(kpiId);
    });

    this.laster$.next(false);
    this.collector.unsubscribe();
  }
}
